import { useState, useEffect } from "react";

const testimonials = [
  {
    name: "Shivam",
    role: "Software Engineer",
    quote: "I purchased a plot from NexEdge Infra in their Nex Greens Enclave project. The entire process was transparent, rates were genuine, and they delivered all approvals on time. Highly recommended for anyone looking for investment in Dehradun.",
    rating: 5,
    initials: "S",
  },
  {
    name: "K.K. Pathak",
    role: "Owner, ACSPL",
    quote: "As a business owner, I needed commercial space in Dehradun. NexEdge provided us with excellent options at competitive rates. Their professionalism and after-sales support have been outstanding.",
    rating: 5,
    initials: "KP",
  },
  {
    name: "Satyam Singh",
    role: "Shop Owner",
    quote: "Took a retail shop from NexEdge Infra in their Business Hub project. The location is prime, construction quality is top-notch, and the pricing was very reasonable. My business is thriving because of this investment.",
    rating: 5,
    initials: "SS",
  },
  {
    name: "Rakesh Verma",
    role: "Property Investor",
    quote: "NexEdge offered me the best plot rates in Dehradun. The documentation was clean, registration was smooth, and they guided me through every step. Genuine company with honest dealings.",
    rating: 5,
    initials: "RV",
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setActive(a => (a + 1) % testimonials.length), 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-28 bg-red-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 text-red-600 text-xs font-semibold tracking-widest uppercase
            bg-white border border-red-100 px-4 py-2 rounded-full mb-6">
            Client Voices
          </div>
          <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 'clamp(2.2rem,5vw,3.5rem)' }}
            className="text-red-950">
            WHAT OUR <span className="text-blue-700">CLIENTS SAY</span>
          </h2>
          <p className="text-slate-500 mt-4 max-w-xl mx-auto text-sm" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Hear from our happy customers who trusted us for their land and property needs
          </p>
        </div>

        {/* Testimonial card */}
        <div className="relative bg-white rounded-3xl p-10 md:p-14 shadow-xl shadow-red-100 min-h-64">
          {/* Quote mark */}
          <div className="absolute top-8 left-10 text-red-100" style={{ fontSize: '6rem', lineHeight: 1, fontFamily: 'Georgia, serif' }}>
            "
          </div>

          <div className="relative z-10">
            {testimonials.map((t, i) => (
              <div key={t.name}
                className={`transition-all duration-500 absolute inset-0 p-10 md:p-14 ${
                  i === active ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
                }`}>
                <div className="flex gap-1 mb-5">
                  {[...Array(t.rating)].map((_, j) => (
                    <svg key={j} className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                    </svg>
                  ))}
                </div>

                <p className="text-slate-700 text-lg md:text-xl leading-relaxed mb-8"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}>
                  "{t.quote}"
                </p>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-900 to-blue-900 rounded-full flex items-center justify-center shadow-md">
                    <span className="text-white font-bold text-sm">{t.initials}</span>
                  </div>
                  <div>
                    <div className="text-red-950 font-bold text-lg"
                      style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.1rem' }}>
                      {t.name}
                    </div>
                    <div className="text-slate-500 text-sm">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Spacer for height */}
          <div className="opacity-0 pointer-events-none p-10 md:p-14">
            <div className="mb-5 h-5"/>
            <p className="text-lg md:text-xl leading-relaxed mb-8 max-w-2xl">
              {testimonials[active].quote}
            </p>
            <div className="h-12"/>
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-3 mt-8">
          {testimonials.map((_, i) => (
            <button key={i} onClick={() => setActive(i)}
              className={`transition-all duration-300 rounded-full ${
                i === active ? 'w-8 h-3 bg-red-600' : 'w-3 h-3 bg-red-200 hover:bg-red-400'
              }`}/>
          ))}
        </div>
      </div>
    </section>
  );
}